var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-right":"20px"}},[_c('el-date-picker',{attrs:{"value-format":"timestamp","type":"daterange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期"},on:{"change":_vm.changeTime},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }